import React, { useState } from 'react'
import styled from 'styled-components'
import { priceFormatter } from '../../logic/financials/precise'
import { SmallCheckCircle } from '../catalog/icons/CheckCircle'
import { swaapGreen1, swaapRed0 } from '../Themes'
import { badPriceThreshold } from '../../config'
import { priceBroker } from '../../api/oracle/oracle-client'

const FairPrice = styled.div`
  color: ${swaapGreen1};
`
const BadPrice = styled.div`
  color: ${swaapRed0};
`

const Style = styled.div`
  font-family: Montserrat;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.shadowText};
  outline: none;
  text-decoration: none;
  text-align: right;
  &:hover {
    opacity: 0.8;
  }
  min-height: 20px;
`

interface Props {
  tokenInValue?: number | undefined
  tokenOutValue?: number | undefined
}

function SwapFairPriceWrapper(props: Props) {
  if (props.tokenOutValue && props.tokenInValue) {
    const discount = 1 - 1 / props.tokenOutValue! / (1 / props.tokenInValue!)
    return (
      <Style>
        {discount < badPriceThreshold ? (
          <BadPrice data-cy="fair-price">
            {priceFormatter(-discount * 100, 3)}% more expensive{' '}
            <span className="light">than {priceBroker}.</span>
          </BadPrice>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'right',
              justifyContent: 'end',
            }}
            data-cy="fair-price"
          >
            <SmallCheckCircle />
            <span style={{ width: '0.5rem' }}> </span>
            <FairPrice>
              {discount > 0 ? (
                <span>
                  {priceFormatter(discount * 100, 3)}% cheaper{' '}
                  <span className="light">than {priceBroker}.</span>
                </span>
              ) : (
                <span>
                  Within {parseFloat((-badPriceThreshold * 100).toFixed(2))}%{' '}
                  <span className="light">of {priceBroker}.</span>
                </span>
              )}
            </FairPrice>
          </div>
        )}
      </Style>
    )
  } else {
    return <Style>&nbsp;</Style>
  }
}
export default SwapFairPriceWrapper
